import { ContextVariable } from "./context-variable";

export class UserContext {
    static context:string = 'USERDEFINED';
    data:Array<ContextVariable>;
}